export enum Routes {
  signUp = '/sign-up',
  signUpCompany = '/sign-up/company',
  signUpProject = '/sign-up/project',
  signUpSuccess = '/sign-up/success',
  signUpActivate = '/activate/:token',
  signUpAdmin = '/sign-up/admin',
  signIn = '/sign-in',
  profile = '/profile',
  unknownError = '/500',
  contact = '/contact',
  home = '/',
  about = 'about',
  blog = '/blogs',
  videos = '/videos',
  impact = '/impact',
  IndividualTakeAction = 'IndividualTakeAction',
  CommunityTakeAction = 'CommunityTakeAction',
  CompanyTakeAction = 'CompanyTakeAction',
  BlogDetails = 'blogs/:id',
  Terms = 'Terms',
  ProjectDetails = 'ProjectDetails/:id',
}
